/* =====================================================================
   Fiche Brainstoorm Café, nouvelle DA (sections/mng-pdp-cafe.liquid).
   Portage du JS de la maquette (PDP-CAFE-REFONTE-2026-09-26/maquette/_scripts/gen.py + home v6),
   branché sur les vraies données et le vrai panier :
   - prix : JSON script[data-mpc-data] écrit par le Liquid (variantes, allocation du plan, prix par tasse,
     % par format) ; ce script ne fait que les afficher, il ne calcule aucun prix ;
   - panier : POST /cart/add.js {items:[{id, quantity, selling_plan}]} puis évènement « cart:updated »,
     comme assets/mng-collection-v3.js : le tiroir du thème se met à jour et s'ouvre ;
   - barre collante : déplacée dans un hôte enfant de <body> (#mng-pdp-cafe-fixe), car #MainContent
     porte contain:layout (assets/audit-fixes.css), qui casse position:fixed ;
   - bulle WhatsApp du thème : remontée au-dessus de la barre collante via --satc-h (snippets/whatsapp.liquid).
   Aucun localStorage, aucun panier maison.
   ===================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('mng-pdp-cafe');
  if (!root || root.getAttribute('data-mpc-ready') === '1') return;
  root.setAttribute('data-mpc-ready', '1');

  var CFG = JSON.parse(root.querySelector('script[data-mpc-data]').textContent);
  var V = CFG.v || [], CUR = CFG.cur || 'EUR', LOC = CFG.loc || 'fr';
  /* langue : textes IT / ES lus dans le JSON #mng-pdp-cafe-i18n posé par la section hors FR (absent en FR : textes
     français ci-dessous, inchangés). traductions-it-es/traduire.py */
  var I18N = {};
  try { var i18nEl = document.getElementById('mng-pdp-cafe-i18n'); if (i18nEl) I18N = JSON.parse(i18nEl.textContent) || {}; }
  catch (e) { console.error('[mng-pdp-cafe] textes de langue illisibles', e); }
  if (CFG.err) console.error('[mng-pdp-cafe] données du bloc d\'achat : ' + CFG.err);

  function q(s, r) { return (r || root).querySelector(s); }
  function qa(s, r) { return (r || root).querySelectorAll(s); }
  function each(l, f) { Array.prototype.forEach.call(l, f); }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* montant en centimes → « 49,90 € » (espace insécable), comme la maquette et le snippet mng-pdp-cafe-prix */
  function eur(c) {
    if (CUR === 'EUR') return (c / 100).toFixed(2).replace('.', ',') + ' €';
    /* 25/10/2026 (PAYS-NL-HR-RO-2026-10-25/RESTES) : lei roumains écrits « lei » (comme Liquid et le paiement), pas « RON » */
    try { var s = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR }).format(c / 100); return CUR === 'RON' ? s.replace('RON', 'lei') : s; }
    catch (e) { return (c / 100).toFixed(2) + ' ' + CUR; }
  }

  /* ---------- barre collante : hôte enfant de <body> ---------- */
  var st = q('#pdsticky');
  var host = document.createElement('div');
  host.id = 'mng-pdp-cafe-fixe';
  if (st) { host.appendChild(st); document.body.appendChild(host); }

  /* ---------- apparitions, compteurs, inclinaison (home v6) ---------- */
  (function () {
    var els = [].slice.call(qa('.rvl,[data-rv-children] li'));
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('in'); }); }
    else {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: .18, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (e) { io.observe(e); });
    }
    var fmt = function (v, d) { return v.toLocaleString('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    each(qa('[data-count]'), function (el) {
      var to = parseFloat(el.dataset.count), d = +(el.dataset.dec || 0), done = false;
      if (reduce || !('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || done) return; done = true; var t0 = null;
        function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e, d); if (k < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      }, { threshold: .6 });
      o.observe(el);
    });
    if (!reduce && matchMedia('(hover:hover)').matches) {
      each(qa('.tilt'), function (c) {
        c.addEventListener('pointermove', function (ev) { var r = c.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5; c.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg'); });
        c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
      });
    }
  })();

  /* ---------- bloc d'achat ---------- */
  var f = CFG.def || 0, m = CFG.mode === 'abo' ? 'abo' : 'uni';
  /* 19/10/2026 (TRADUCTION-UK-2026-10-19) : Royaume-Uni en anglais (CFG.pc_uk, posé par le Liquid), visiteur venu de
     PureComparatif (utm_source=purecomparatif… dans l'URL, ou cookie discount_code=PC posé par /discount/PC) : 1 sachet en
     abonnement coché d'emblée, le prix annoncé par le comparatif. Sans ce drapeau ou sans ces signaux : rien ne change. */
  if (CFG.pc_uk && V[0] && V[0].ok && V[0].a != null &&
      (/[?&]utm_source=purecomparatif/i.test(location.search) || /(?:^|;\s*)discount_code=PC(?:;|$)/i.test(document.cookie))) {
    f = 0; m = 'abo';
  }
  function setTxt(sel, txt, r) { var el = q(sel, r); if (el) el.textContent = txt; }
  function r() {
    var x = V[f];
    if (!x) return;
    if (x.a == null) m = 'uni';   /* variante sans le plan : pas d'abonnement possible */
    each(qa('.pd-fmt button'), function (b, i) {
      var on = i === f, o = V[i];
      b.classList.toggle('on', on);
      b.setAttribute('aria-checked', on);
      if (!o) return;
      var cup = b.querySelector('.pd-cup b');
      if (cup) cup.textContent = eur(o.a != null ? o.ca : o.cu); /* prix par tasse = toujours celui de l'abonnement (Alex, 26/09) */
      var pct = b.querySelector('.pd-pct');
      /* % du format : affiché en abonnement ET en achat unique, comme la fiche actuelle (test A/B) */
      if (pct) pct.hidden = o.a == null;
      /* « Livraison offerte » : toujours en abonnement, en achat unique seulement au-dessus du seuil (o.lu, Liquid) */
      var liv = b.querySelector('.pd-liv');
      /* 19/10/2026 (BOUTIQUE-CZ-PL-2026-10-19) : CFG.abo_payant (CZ, PL) = abonnement livré payant : en abonnement, pas de pastille ;
         sans ce drapeau, comportement d'avant à l'identique. */
      var aboOk = m === 'abo' && o.a != null;
      /* 22/10/2026 (traduction-site-2210) : CFG.seuil_fx (centimes d'euro, Liquid) = seuil du pays dans une devise que Liquid ne
         convertit pas (kr, CHF…) : comparé ici au prix du format au taux Shopify. Sans ce champ : o.lu, comme avant. */
      var lu = o.lu, fxr = window.Shopify && window.Shopify.currency ? parseFloat(window.Shopify.currency.rate) : 0;
      if (CFG.seuil_fx && fxr > 0) lu = o.p >= Math.round(CFG.seuil_fx * fxr);
      if (liv) liv.hidden = !(aboOk ? !CFG.abo_payant : lu);
    });
    each(qa('.pd-mode button'), function (b) {
      var on = b.dataset.m === m;
      b.classList.toggle('on', on);
      b.setAttribute('aria-checked', on);
      if (b.dataset.m === 'abo') b.disabled = x.a == null;
    });
    setTxt('[data-p=abo]', x.a != null ? eur(x.a) : '');
    setTxt('[data-p=barre]', eur(x.p));
    setTxt('[data-p=uni]', eur(x.p));
    var pr = eur(m === 'abo' ? x.a : x.p);
    setTxt('[data-p=cta]', pr);
    /* barre collante (structure de la barre de la fiche actuelle) : prix, barré, économie, formule, formats, note */
    var abo = m === 'abo' && x.a != null;
    setTxt('[data-p=cta2]', pr, host);
    setTxt('[data-p=sticky]', x.u + (I18N.por || ' portions \u00b7 ') + (abo ? (I18N.abo || 'Offre d\u00e9couverte') : (I18N.uni || 'Achat unique')), host);
    var was = q('[data-p=st-was]', host), save = q('[data-p=st-save]', host), segsave = q('[data-p=st-segsave]', host);
    if (was) { was.textContent = eur(x.p); was.hidden = !abo; }
    if (save) { save.textContent = '-' + eur(x.sv || 0); save.hidden = !abo || !x.sv; }
    if (segsave) { segsave.textContent = '-' + eur(x.sv || 0); segsave.hidden = !abo || !x.sv; }
    /* 21/10/2026 (traduction-site-2110) : I18N.note_uni_html (Liquid, langues autres que fr/it/es hors Royaume-Uni anglais et CZ/PL) =
       seuil de livraison du pays, montant dans <span data-mng-seuil> converti dans la devise par mng-livraison-seuil
       (window.mngSeuilFx), comme le reste de la page ; vide si le pays n'a pas de livraison offerte. Sans ce champ : inchangé. */
    var stNote = q('[data-p=st-note]', host);
    if (!abo && stNote && typeof I18N.note_uni_html === 'string') { stNote.innerHTML = I18N.note_uni_html; if (window.mngSeuilFx) window.mngSeuilFx(stNote); }
    else setTxt('[data-p=st-note]', abo ? (I18N.note_abo || 'Livraison offerte \u00b7 Sans engagement') : (I18N.note_uni || 'Livraison offerte d\u00e8s 59\u00a0\u20ac'), host);
    each(qa('.pst-seg', host), function (b) {
      var on = b.dataset.m === m;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on);
      if (b.dataset.m === 'abo') b.disabled = x.a == null;
    });
    each(qa('.pst-opt[data-f]', host), function (b) {
      var on = +b.dataset.f === f;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on);
    });
    syncPicks();
    var cta = q('.pd-cta');
    if (cta && cta.getAttribute('aria-busy') !== 'true') cta.disabled = !x.ok;
  }
  each(qa('.pd-fmt button'), function (b) { b.addEventListener('click', function () { if (b.disabled) return; f = +b.dataset.f; r(); }); });
  each(qa('.pd-mode button'), function (b) { b.addEventListener('click', function () { if (b.disabled) return; m = b.dataset.m; r(); }); });
  /* barre collante → bloc d'achat : même état, les deux se mettent à jour */
  each(qa('.pst-seg', host), function (b) { b.addEventListener('click', function () { if (b.disabled) return; m = b.dataset.m; r(); }); });
  each(qa('.pst-opt[data-f]', host), function (b) { b.addEventListener('click', function () { if (b.disabled) return; f = +b.dataset.f; r(); }); });

  /* pastilles de la barre (tablette, téléphone) : défilement horizontal, fondu tant qu'il en reste à voir,
     pastille de format active ramenée dans le champ quand elle change (comme la barre de la fiche actuelle) */
  var picks = q('.pst-picks', host), lastAct = null;
  function syncPicks() {
    if (!picks) return;
    var more = picks.scrollWidth - picks.clientWidth > 2 && picks.scrollLeft + picks.clientWidth < picks.scrollWidth - 2;
    picks.classList.toggle('is-scrollable', more);
    var act = q('.pst-pick--format .pst-opt.on', host);
    if (!act || act === lastAct) return;
    lastAct = act;
    if (picks.scrollWidth - picks.clientWidth <= 2) return;
    var pr2 = picks.getBoundingClientRect(), ar = act.getBoundingClientRect();
    if (ar.right > pr2.right - 28) picks.scrollLeft += ar.right - pr2.right + 36;
    else if (ar.left < pr2.left) picks.scrollLeft -= pr2.left - ar.left + 12;
  }
  if (picks) {
    picks.addEventListener('scroll', function () { picks.classList.toggle('is-scrollable', picks.scrollLeft + picks.clientWidth < picks.scrollWidth - 2); }, { passive: true });
    window.addEventListener('resize', syncPicks);
  }

  /* ---------- galerie ---------- */
  var G = qa('.pd-slide'), T = qa('.pd-th button'), gi = 0;
  /* photos 2 à 16 : data-src (sinon les 16 photos empilées partent toutes au 1er affichage) ;
     chargées après le chargement de la page, et tout de suite (avec leurs voisines) si on les affiche */
  function charge(k) {
    var s = G[(k + G.length) % G.length], im = s && s.querySelector('img[data-src]');
    if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
  }
  function chargeTout() { for (var k = 0; k < G.length; k++) charge(k); }
  if (document.readyState === 'complete') setTimeout(chargeTout, 1200);
  else window.addEventListener('load', function () { setTimeout(chargeTout, 1200); });
  function show(i) {
    gi = (i + G.length) % G.length;
    charge(gi); charge(gi + 1); charge(gi - 1);
    each(G, function (s, k) { s.classList.toggle('on', k === gi); });
    each(T, function (t, k) { t.classList.toggle('on', k === gi); });
    var c = q('.pd-count b'); if (c) c.textContent = gi + 1;
    var th = T[gi];
    if (th && th.scrollIntoView && th.parentNode.scrollWidth > th.parentNode.clientWidth) th.parentNode.scrollLeft = th.offsetLeft - th.parentNode.clientWidth / 2 + th.offsetWidth / 2;
  }
  if (G.length) {
    each(T, function (b, k) {
      b.addEventListener('click', function () { show(k); });
      b.addEventListener('pointerenter', function () { charge(k); });
    });
    var gal = q('.pd-main');
    if (gal) gal.addEventListener('pointerenter', function () { charge(gi + 1); charge(gi - 1); });
    var prev = q('.pd-prev'), next = q('.pd-next'), m0 = q('.pd-main');
    if (prev) prev.addEventListener('click', function () { show(gi - 1); });
    if (next) next.addEventListener('click', function () { show(gi + 1); });
    var sx = null;
    if (m0) {
      m0.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      m0.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); sx = null; });
    }
  }

  /* ---------- vidéos clients : sources posées à l'approche de l'écran (data-src, preload="none") ---------- */
  var vids = [].slice.call(qa('video'));
  function joue(v) {
    if (v.getAttribute('data-mpc-src') === '1') return;
    v.setAttribute('data-mpc-src', '1');
    each(v.querySelectorAll('source[data-src]'), function (so) { so.src = so.getAttribute('data-src'); so.removeAttribute('data-src'); });
    v.preload = 'auto';
    v.load();
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () { /* lecture automatique refusée (économie de données) : l'affiche reste */ });
  }
  if (vids.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { joue(x.target); vio.unobserve(x.target); } });
      }, { rootMargin: '400px 0px 400px 0px' });
      vids.forEach(function (v) { vio.observe(v); });
    } else { vids.forEach(joue); }
  }

  /* ---------- ajout au panier : même requête et même évènement que la collection ---------- */
  var busy = false, errEl = q('.pd-err');
  function add(b, item, done) {
    if (busy || !item) return;
    busy = true;
    var t = b.innerHTML;
    b.setAttribute('aria-busy', 'true');
    if (errEl) errEl.hidden = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (res.ok) return res.json();
      return res.json().catch(function () { return {}; }).then(function (j) {
        throw new Error(j.description || j.message || ('/cart/add.js ' + res.status));
      });
    }).then(function () {
      busy = false;
      b.removeAttribute('aria-busy');
      b.textContent = done;
      b.classList.add('added');
      setTimeout(function () { b.innerHTML = t; b.classList.remove('added'); r(); }, 1600);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function (e) {
      busy = false;
      b.removeAttribute('aria-busy');
      console.error('[mng-pdp-cafe] ajout au panier', e);
      if (errEl) { errEl.textContent = (I18N.err || 'Erreur lors de l\'ajout au panier : ') + ((e && e.message) || I18N.retry || 'réessayez.'); errEl.hidden = false; }
      r();
    });
  }
  function itemCourant() {
    var x = V[f];
    if (!x || !x.ok) return null;
    /* MNG 19/10/2026 TEST-PRIX-2026-10 : sur une copie de test de prix, l'abonnement ajoute la variante d'ORIGINE (x.aid,
       même SKU) avec son plan ; x.aid n'existe pas sur les fiches d'origine (comportement inchangé). */
    return { id: (m === 'abo' && x.aid) ? x.aid : x.id, quantity: 1, selling_plan: m === 'abo' && x.sp != null ? x.sp : null };
  }
  var cta = q('.pd-cta');
  if (cta) cta.addEventListener('click', function () { add(cta, itemCourant(), (I18N.added || 'Ajouté au panier ✓')); });
  var pk = q('.pk-cta');
  if (pk && CFG.pack) pk.addEventListener('click', function () { add(pk, { id: CFG.pack.id, quantity: 1, selling_plan: CFG.pack.sp }, (I18N.added || 'Ajouté au panier ✓')); });
  var sb = st && q('.pst-btn', st);
  if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); add(sb, itemCourant(), (I18N.added || 'Ajouté au panier \u2713')); });

  /* ---------- barre collante : visible quand le bouton d'achat est passé et le pied de page pas encore là ---------- */
  var ft = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
  var stOn = false;
  function satc() {
    /* bulle WhatsApp du thème (snippets/whatsapp.liquid lit --satc-h) */
    var want = stOn ? st.offsetHeight + 'px' : '0px';
    if (document.documentElement.style.getPropertyValue('--satc-h') !== want) document.documentElement.style.setProperty('--satc-h', want);
  }
  if (st && cta) {
    /* même règle que la maquette (bouton d'achat visible ou encore plus bas, ou pied de page visible → barre
       cachée), mesurée au défilement : un saut de défilement (lien, retour en haut) ne la laisse pas affichée */
    var raf = 0;
    var u = function () {
      raf = 0;
      var c = cta.getBoundingClientRect().bottom > 0;
      var fv = ft ? ft.getBoundingClientRect().top < window.innerHeight : false;
      var on = !c && !fv;
      if (on !== stOn || st.classList.contains('on') !== on) {
        stOn = on; st.classList.toggle('on', on);
        st.setAttribute('aria-hidden', on ? 'false' : 'true');
        st.inert = !on;
        if (on) syncPicks();
      }
      satc();
    };
    var sched = function () { if (!raf) raf = requestAnimationFrame(u); };
    window.addEventListener('scroll', sched, { passive: true });
    window.addEventListener('resize', sched);
    u();
    /* le script des cartes cures (mng-collection-v3.js) remet --satc-h à 0 sur ses évènements : on le repose */
    new MutationObserver(function () { if (stOn) satc(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  }

  /* ---------- liens internes (#acheter, #avis, #fondateur) : défilement doux, comme la maquette ---------- */
  function onAnchor(e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var tg = id && document.getElementById(id);
    if (!tg) return;
    e.preventDefault();
    tg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    try { history.replaceState(history.state, '', '#' + id); } catch (err) {}
  }
  root.addEventListener('click', onAnchor);

  /* ---------- « En combien de temps » : la ligne se remplit en violet quand la frise entre à l'écran ---------- */
  var tl = q('[data-tl]');
  if (tl) {
    var rail = q('.px-tl2-rail', tl), dots = qa('.px-tl2-dot', tl);
    /* la ligne va du centre du 1er jalon au centre du dernier (horizontale, ou verticale au téléphone) */
    var place = function () {
      if (!rail || dots.length < 2) return;
      /* positions sans le décalage d'apparition (.rvl : translate) des jalons */
      var box = function (d) {
        var r0 = d.getBoundingClientRect(), it = d.closest('.px-tl2-it'), tr = it ? getComputedStyle(it).translate : '';
        var p = tr && tr !== 'none' ? tr.split(' ') : [];
        var tx = parseFloat(p[0]) || 0, ty = parseFloat(p[1]) || 0;
        return { left: r0.left - tx, top: r0.top - ty, width: r0.width, height: r0.height };
      };
      var b = tl.getBoundingClientRect(), d0 = box(dots[0]), d1 = box(dots[dots.length - 1]);
      var vertical = Math.abs(d1.left - d0.left) < 4;
      var th = 6;
      if (vertical) {
        rail.style.left = (d0.left + d0.width / 2 - b.left - th / 2) + 'px'; rail.style.right = 'auto'; rail.style.width = th + 'px';
        rail.style.top = (d0.top + d0.height / 2 - b.top) + 'px'; rail.style.height = (d1.top - d0.top) + 'px'; rail.style.bottom = 'auto';
      } else {
        rail.style.top = (d0.top + d0.height / 2 - b.top - th / 2) + 'px'; rail.style.bottom = 'auto'; rail.style.height = th + 'px';
        rail.style.left = (d0.left + d0.width / 2 - b.left) + 'px'; rail.style.width = (d1.left - d0.left) + 'px'; rail.style.right = 'auto';
      }
    };
    place();
    window.addEventListener('resize', place);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    if (reduce || !('IntersectionObserver' in window)) tl.classList.add('on');
    else {
      var tio = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { place(); tl.classList.add('on'); tio.disconnect(); }
      }, { threshold: .35 });
      tio.observe(tl);
    }
  }

  /* ---------- préparation : 3 photos qui défilent, survol / clic / focus, barre de progression ---------- */
  var stp = qa('.px-steps li'), pi = qa('.px-prep-ph img'), ul = q('.px-steps'), si = 0, tm = null, live = true;
  function step(i) {
    si = i % stp.length;
    each(stp, function (l, k) { l.classList.toggle('on', k === si); });
    each(pi, function (im, k) { im.classList.toggle('on', k === si); });
    if (ul) { ul.classList.remove('auto'); void ul.offsetWidth; if (live) ul.classList.add('auto'); }
  }
  function loop() { clearInterval(tm); if (live) tm = setInterval(function () { step(si + 1); }, 3200); }
  if (stp.length) {
    each(stp, function (l, k) { var go = function () { live = false; clearInterval(tm); step(k); }; l.addEventListener('mouseenter', go); l.addEventListener('click', go); l.addEventListener('focus', go); });
    if (ul) {
      ul.addEventListener('mouseleave', function () { live = true; step(si); loop(); });
      if ('IntersectionObserver' in window && !reduce) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting) { step(si); loop(); } else clearInterval(tm); }).observe(ul);
      }
    }
  }

  r();
})();
